import { trackPageView } from "GTMs/libs";
import { useEffect } from "react";
import {EnumScreenNames} from "../enums/EnumScreenNames";

export default function useTrackPageView(
  enumScreenName:EnumScreenNames | string,
  withExtra = false,
  isDialog = false,
  timeout = 100
) {
  useEffect(() => {
    trackPageView(enumScreenName, isDialog, timeout);
  }, []);
}
